module.exports = __webpack_public_path__ + "static/media/worldo.1e6bed24.png";